'use strict';

module.exports = function (include) {
    if (typeof include === 'function') {
        include();
    } else if (typeof include === 'object') {
        Object.keys(include).forEach(function (key) {
            if (typeof include[key] === 'function') {
                include[key]();
            }
        });
    }
};

$(document).ready(function () {
    $('body').on('click', '#quickViewModal .modal-body .detail-panel .attributes .color-attribute', function() {
        $('#quickViewModal .modal-body .detail-panel .attributes .color-attribute').removeClass('selected');
        $(this).addClass('selected');
    });
    $('body').on('click', '#editProductModal .modal-body .detail-panel .attributes .color-attribute', function() {
        $('#editProductModal .modal-body .detail-panel .attributes .color-attribute').removeClass('selected');
        $(this).addClass('selected');
    });
    $('body').on('click', '#editWishlistProductModal .modal-body .detail-panel .attributes .color-attribute', function() {
        $('#editWishlistProductModal .modal-body .detail-panel .attributes .color-attribute').removeClass('selected');
        $(this).addClass('selected');
    });
    $('.custom-control-input[type="radio"], .custom-control-input[type="checkbox"]').change(function(){
        (this).blur();
    });
});

if ($(".checkout-continue").length) {
  $(".footer-bottom").addClass("in");
}



// WEBPACK FOOTER //
// ./cartridges/app_fh/cartridge/client/default/js/util.js